import React from 'react';
import { useSelector } from 'react-redux';
import { Point } from '@printu/geom';
import { getItemAbsoluteVertices } from 'app/core/markers/bounds';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { Edit } from './Edit';
const HandleIds = {
    tl: 'tl',
    tr: 'tr',
    br: 'br',
    bl: 'bl',
};
const createHandles = (marker) => {
    const [tl, tr, br, bl] = getItemAbsoluteVertices(marker);
    return {
        [HandleIds.tl]: {
            current: tl.toObject(),
        },
        [HandleIds.tr]: {
            current: tr.toObject(),
        },
        [HandleIds.br]: {
            current: br.toObject(),
        },
        [HandleIds.bl]: {
            current: bl.toObject(),
        },
    };
};
export const EditBoundsPoints = (props) => {
    var _a;
    const keepAspectRatio = (_a = props === null || props === void 0 ? void 0 : props.keepAspectRatio) !== null && _a !== void 0 ? _a : false;
    const marker = useSelector(state => {
        const project = getProjectState(state);
        const selectedItemId = project.selection[0];
        if (!selectedItemId) {
            return undefined;
        }
        return project.markers[selectedItemId];
    });
    const dispatch = useAppDispatch();
    const onHandleChanged = React.useCallback((handleId, point, _downPoint, initial) => {
        if (!marker) {
            return undefined;
        }
        let patch;
        const { abs } = Math;
        const [tl, tr, br, bl] = getItemAbsoluteVertices(marker);
        let currentX = point.virtual.x;
        let currentY = point.virtual.y;
        // for aspect ratio use hypotenuse
        if (keepAspectRatio) {
            let hypotPt;
            let vec;
            switch (handleId) {
                case HandleIds.tl:
                    hypotPt = { x: br.x, y: br.y };
                    vec = Point.from(tl.x - br.x, tl.y - br.y);
                    break;
                case HandleIds.tr:
                    hypotPt = { x: bl.x, y: bl.y };
                    vec = Point.from(tr.x - bl.x, tr.y - bl.y);
                    break;
                case HandleIds.br:
                    hypotPt = { x: tl.x, y: tl.y };
                    vec = Point.from(br.x - tl.x, br.y - tl.y);
                    break;
                case HandleIds.bl:
                    hypotPt = { x: tr.x, y: tr.y };
                    vec = Point.from(bl.x - tr.x, bl.y - tr.y);
                    break;
                default:
                    return undefined;
            }
            const currentVec = new Point(point.virtual.x - hypotPt.x, point.virtual.y - hypotPt.y);
            vec.normalize(currentVec.length);
            currentX = vec.x + hypotPt.x;
            currentY = vec.y + hypotPt.y;
        }
        switch (handleId) {
            case HandleIds.tl:
                patch = {
                    x: currentX,
                    y: currentY,
                    endX: abs(br.x - currentX),
                    endY: abs(br.y - currentY),
                };
                break;
            case HandleIds.tr:
                patch = {
                    x: tl.x,
                    y: currentY,
                    endX: abs(currentX - tl.x),
                    endY: abs(bl.y - currentY),
                };
                break;
            case HandleIds.br:
                patch = {
                    x: tl.x,
                    y: tl.y,
                    endX: abs(currentX - tl.x),
                    endY: abs(currentY - tl.y),
                };
                break;
            case HandleIds.bl:
                patch = {
                    x: currentX,
                    y: tl.y,
                    endX: abs(br.x - currentX),
                    endY: abs(currentY - tr.y),
                };
                break;
            default:
                break;
        }
        if (patch) {
            dispatch(ProjectActions.itemUpdate({
                id: marker.id,
                patch,
                undoable: initial,
            }));
        }
        return undefined;
    }, [marker, keepAspectRatio, dispatch]);
    return (React.createElement(Edit, { handles: createHandles(marker), onHandleChanged: onHandleChanged }));
};
